import React, {CSSProperties, FC, forwardRef, Ref, useState} from 'react';
import {observer} from 'mobx-react';
import Box from '../Common/Box';
import logMessageStore, {EVENT_LOG_LOGGER_ID, Message} from '../lib/logMessageStore';
import List from "../Messages/List";
import {TextField} from "@mui/material";

interface Props {
    expand?: boolean;
    focused?: boolean;

    [prop: string]: any;
}

interface RowProps {
    index: number;
    height: number;
    style: CSSProperties;
    observer?: boolean;
}

// interface Message {
//     id: string;
//     content: string;
//     color: string;
// }

function EventLog(
        {
            expand,
            focused = true,
            ...props
        }: Props
) {

    const [filter, setFilter] = useState<string>("");
    const rawMessages: Message[] = logMessageStore.getMessages();
    const messages: Message[] = rawMessages.filter(message => message.content.toLowerCase().includes(filter.toLowerCase()));

    const Row: FC<RowProps> = observer(forwardRef((
            {
                index,
                height,
                style,
                observer: isObserver
            }: RowProps, ref: Ref<HTMLDivElement>) => {

        const innerStyle: CSSProperties = {};

        if (isObserver) {
            innerStyle["background"] = "#00aaff"
        }

        const message: Message = messages[index];

        return <div
                ref={ref}
                style={style}
        >
            <Box
                    padding={"10px 10px 10px"}
                    color={message.color}
                    fontSize={"12px"}
                    border={"2px solid"}
                    borderRadius={"4px"}
                    margin={"10px 10px 0 10px"}
                    sx={
                        {
                            wordBreak: "break-all",
                        }
                    }
            >
                {
                    message.content
                }
            </Box>
        </div>

    }));

    return <Box
            id={"event-log"}
            flex={1}
            expand={expand || true
            }
            padding={"0"}
            column
            overflow={"auto"}
            {...
                    props
            }
    >
        <List
                id={EVENT_LOG_LOGGER_ID}
                width={"100%"}
                items={messages}
                style={
                    {
                        flex: 1
                    }
                }
        >
            {
                Row
            }
        </List>
        {
                focused && <TextField
                        multiline
                        maxRows={1}
                        value={filter}
                        onChange={event => setFilter(event.target.value)
                        }
                />}
    </Box>
}

export default observer(EventLog);
